import { Typography } from "antd";
import { useIntl } from "react-intl";
import { transactionStateColor } from "@lib/helpers/ColorHelper";
import { TransactionProxyState } from "@lib/types/Transaction";
import { shortenString } from "@lib/helpers/StringHelper";
import styled from "styled-components";

type Props = {
  state: TransactionProxyState;
  shorten?: boolean;
  size?: "small" | "medium";
};

const StyledTypography = styled(Typography.Text)<{ size?: "small" | "medium" }>`
  &.ant-typography {
    background-color: ${({ color }) => color};
    padding: 2px 4px;
    border-radius: 4px;
    color: ${({ theme }) => theme.palette.white}!important;
    font-size: ${({ size }) => (size === "small" ? "10px" : "12px")};
  }
`;

export default function PaymentHistoryState(props: Props) {
  const { state, shorten, size = "medium" } = props;
  const { messages } = useIntl();
  const stateText =
    messages["enums.transactionProxyState"][state] || state || " N/A ";

  return (
    <StyledTypography ellipsis color={transactionStateColor(state)} size={size}>
      {shorten ? shortenString(stateText, 30, true) : stateText}
    </StyledTypography>
  );
}
